export const getAlarms = (state) => {
  return state.alarms;
};
